
export default {
  'subscription.update_success': 'Subscription Updated',
  'subscription.subscribed_to': 'You have successfully subscribed to {{plan}}',
  'subscription.feature_1_title': 'Exclusive Content',
  'subscription.feature_1_description': 'Access all private photos and videos',
  'subscription.feature_2_title': 'Direct Messaging',
  'subscription.feature_2_description': 'Priority messaging and instant responses',
  'subscription.feature_3_title': 'Special Services',
  'subscription.feature_3_description': 'Access to premium services and special offers',
  'subscription.monthly_subscription': 'Monthly Subscription',
  'subscription.month': 'month',
  'subscription.cancel_anytime': 'Cancel anytime, no commitment required',
  'subscription.terms_notice': 'By subscribing, you agree to our Terms of Service and Privacy Policy',
  'subscription.premium_content': 'Premium Content',
  'subscription.premium_description': 'Get exclusive access to premium content and services',
  'subscription.subscribe_to': 'Subscribe to',
  'subscription.subscribe_for': 'Subscribe for',
  'subscription.processing': 'Processing...',
  'subscription.cancel': 'Cancel',
  'subscription.continue': 'Continue',
  'subscription.thank_you': 'Thank You!',
  'subscription.access_granted': 'You now have access to exclusive content'
};
